
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8","cy":"8","r":"7","stroke":"currentColor","stroke-width":"2"}}),_c('rect',{attrs:{"x":"7","y":"4","width":"2","height":"5","rx":"1","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"8","cy":"11","r":"1","fill":"currentColor"}})])
          )
        }
      }
    